// EM²c active resource-system rules.
// Hydrated Mineral Zone → Regolith Water Extractor → Raw Water →
// Water Purification Plant → Clean Water. There is NO ice resource stage.

import { EM2C_BUILDINGS, EM2C_BUILDING_LIST } from "./em2c-buildings";

export const HYDRATED_MINERAL_KIND = "hydrated_minerals";
export const RAW_WATER_TANK_CAPACITY = 150;
export const CLEAN_WATER_RESERVOIR_CAPACITY = 450;
export const ATMOSPHERIC_WATER_OUTPUT = 0.8;

export const RESIDENT_INPUTS_PER_COLONIST = {
  water: 0.3,
  oxygen: 0.4,
  food: 0.15,
};

export const RESIDENT_BYPRODUCTS_PER_COLONIST = {
  co2: 0.32,
  wastewater: 0.24,
  organic_waste: 0.08,
  waste: 0.02,
};

const HABITAT_PROFILES = {
  habitat_module: 6,
  crew_quarters: 4,
  habitat_complex: 24,
};

export function applyResourceSystemRules() {
  const extractor = EM2C_BUILDINGS.water_extractor;
  if (extractor) {
    extractor.requiresDeposit = HYDRATED_MINERAL_KIND;
    extractor.depositLabel = "Hydrated Mineral Zone";
    extractor.productionInputs = {};
    extractor.productionOutputs = { raw_water: 5 };
  }

  const harvester = EM2C_BUILDINGS.atmospheric_water_harvester;
  if (harvester) harvester.productionOutputs = { raw_water: ATMOSPHERIC_WATER_OUTPUT };

  const purifier = EM2C_BUILDINGS.water_purifier;
  if (purifier) {
    purifier.productionInputs = { raw_water: 4 };
    purifier.productionOutputs = { water: 5 };
  }

  const rawTank = EM2C_BUILDINGS.water_tank;
  if (rawTank) rawTank.storageCapacity = { raw_water: RAW_WATER_TANK_CAPACITY };

  const cleanTank = EM2C_BUILDINGS.clean_water_reservoir;
  if (cleanTank) cleanTank.storageCapacity = { water: CLEAN_WATER_RESERVOIR_CAPACITY };

  const oxygen = EM2C_BUILDINGS.oxygen_gen;
  if (oxygen) oxygen.productionOutputs = { oxygen: 4, hydrogen: 1 };

  const atmo = EM2C_BUILDINGS.atmo_processor;
  if (atmo) atmo.productionOutputs = { co2: 4, nitrogen: 0.12, argon: 0.08 };

  for (const [id, residentCapacity] of Object.entries(HABITAT_PROFILES)) {
    const def = EM2C_BUILDINGS[id];
    if (!def) continue;
    def.residentCapacity = residentCapacity;
    def.residentInputsPerColonist = { ...RESIDENT_INPUTS_PER_COLONIST };
    def.byproductsPerResident = { ...RESIDENT_BYPRODUCTS_PER_COLONIST };
    // Empty habitat shells do not consume human water/O₂; real colonist
    // consumption is handled by the population simulation.
    def.waterConsumption = 0;
    def.oxygenConsumption = 0;
  }

  // All Life Support / Food infrastructure is automated at the machinery level.
  // Colonists are population consumers, not an artificial worker gate for these systems.
  for (const building of Object.values(EM2C_BUILDINGS)) {
    if (building.category === "life") building.workersRequired = 0;
  }
  for (const building of EM2C_BUILDING_LIST) {
    if (building.category === "life") building.workersRequired = 0;
  }

  return true;
}

applyResourceSystemRules();
